/**
 * This file was automatically generated by ontology-generator.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSON file in
 * tools/ontology-generator/src/nodespec/relationships.json and re-run the generator.
 *
 * Placement is local (one-hop), not transitive — a Role staffed by an unplaced
 * HumanLabor still counts as placed. Chained clusters are a separate concern.
 */
import type { NodeLabel } from '../../types/schema'
import type { RelationshipType } from './relationships'

export type AnchorDirection = 'in' | 'out'

export interface AnchorPattern {
  type: RelationshipType
  direction: AnchorDirection
  peerLabels: readonly NodeLabel[]
}

export const ANCHOR_PATTERNS_BY_LABEL: Readonly<Record<NodeLabel, ReadonlyArray<AnchorPattern>>> = {
  AOI: [{ type: 'BELONGS_TO', direction: 'out', peerLabels: ['Controller'] }],
  Alarm: [
    { type: 'HAS_ALARM', direction: 'in', peerLabels: ['Tag'] },
    { type: 'HAS_ALARM_DEFINITION', direction: 'in', peerLabels: ['UDTDefinition'] }
  ],
  Area: [{ type: 'PART_OF', direction: 'out', peerLabels: ['Area', 'Site'] }],
  Asset: [
    { type: 'BELONGS_TO', direction: 'out', peerLabels: ['EmdbProject'] },
    { type: 'CONTAINS', direction: 'in', peerLabels: ['Asset', 'Site'] }
  ],
  AuditProfile: [{ type: 'BELONGS_TO', direction: 'out', peerLabels: ['Compute'] }],
  Batch: [
    { type: 'BATCH_OF', direction: 'out', peerLabels: ['WorkOrder'] },
    { type: 'RAN_ON', direction: 'out', peerLabels: ['Equipment'] }
  ],
  BlockLibrary: [],
  BlockParamGroup: [{ type: 'HAS_PARAM_GROUP', direction: 'in', peerLabels: ['BlockType'] }],
  BlockType: [
    { type: 'DERIVED_FROM', direction: 'out', peerLabels: ['BlockType'] },
    { type: 'PARENT_OF', direction: 'in', peerLabels: ['BlockLibrary'] }
  ],
  Cee: [{ type: 'HOSTS', direction: 'in', peerLabels: ['DcsController'] }],
  Compute: [
    { type: 'BELONGS_TO', direction: 'out', peerLabels: ['EmdbProject'] },
    { type: 'CONTAINS', direction: 'in', peerLabels: ['Asset', 'NetworkDevice', 'NetworkSegment'] },
    { type: 'HAS_COMPUTE', direction: 'in', peerLabels: ['Site'] },
    { type: 'MONITORED_BY', direction: 'in', peerLabels: ['Equipment', 'Line'] }
  ],
  ControlAlarm: [{ type: 'HAS_ALARM', direction: 'in', peerLabels: ['ControlTag'] }],
  ControlModule: [{ type: 'ASSIGNED_TO', direction: 'out', peerLabels: ['Cee'] }],
  ControlNamespace: [{ type: 'HOSTS', direction: 'in', peerLabels: ['Compute'] }],
  ControlPattern: [
    { type: 'CONTROLS', direction: 'out', peerLabels: ['PLCTag'] },
    { type: 'HAS_PATTERN', direction: 'in', peerLabels: ['Controller'] }
  ],
  ControlSetpoint: [],
  ControlTag: [
    { type: 'EXPOSES', direction: 'in', peerLabels: ['ControlModule'] },
    { type: 'PROVIDES', direction: 'in', peerLabels: ['ControlNamespace'] }
  ],
  Controller: [
    { type: 'CONTROLLED_BY', direction: 'in', peerLabels: ['Equipment', 'Line'] },
    { type: 'MAPS_TO_CONTROLLER', direction: 'in', peerLabels: ['Compute'] }
  ],
  CrewRequirement: [{ type: 'HAS_CREW_REQUIREMENT', direction: 'in', peerLabels: ['Line'] }],
  Customer: [],
  CustomerOrder: [],
  DataFlow: [{ type: 'HAS_FLOW', direction: 'in', peerLabels: ['PLCTag'] }],
  Database: [{ type: 'HAS_DATABASE', direction: 'in', peerLabels: ['Compute', 'Site'] }],
  DcsController: [{ type: 'MAPS_TO_CONTROLLER', direction: 'in', peerLabels: ['Compute'] }],
  DemandForecast: [],
  DemandHistory: [],
  EmdbProject: [],
  Equipment: [{ type: 'HAS_EQUIPMENT', direction: 'in', peerLabels: ['Equipment', 'Line'] }],
  EquipmentProperty: [{ type: 'HAS_PROPERTY', direction: 'in', peerLabels: ['Equipment'] }],
  FaultCause: [{ type: 'CAUSED_BY', direction: 'in', peerLabels: ['Problem'] }],
  FaultSymptom: [
    { type: 'EXHIBITS_SYMPTOM', direction: 'in', peerLabels: ['Area', 'Equipment', 'Part'] },
    { type: 'INDUCES', direction: 'in', peerLabels: ['Problem'] }
  ],
  Folder: [
    { type: 'CONTAINS', direction: 'in', peerLabels: ['Folder'] },
    { type: 'PROVIDES', direction: 'in', peerLabels: ['TagProvider'] }
  ],
  FunctionBlock: [
    {
      type: 'CONTAINS',
      direction: 'in',
      peerLabels: ['Cee', 'ControlModule', 'DcsController', 'FunctionBlock']
    }
  ],
  FunctionLogicDiagram: [{ type: 'CONTAINS', direction: 'in', peerLabels: ['LogicSolver'] }],
  FunctionalLocation: [{ type: 'PART_OF', direction: 'out', peerLabels: ['FunctionalLocation'] }],
  GatewayEvent: [],
  GatewayEventHandler: [],
  HazardScenario: [{ type: 'PART_OF', direction: 'out', peerLabels: ['Site'] }],
  Holiday: [{ type: 'BELONGS_TO', direction: 'out', peerLabels: ['Compute'] }],
  HumanLabor: [
    { type: 'COVERS', direction: 'in', peerLabels: ['CrewRequirement'] },
    { type: 'REQUIRES_LABOR', direction: 'in', peerLabels: ['Line', 'LineOperation'] },
    { type: 'USES_EQUIPMENT', direction: 'out', peerLabels: ['Equipment'] }
  ],
  Intent: [],
  IoChannel: [
    { type: 'CONTAINS', direction: 'in', peerLabels: ['IoModule'] },
    { type: 'MOUNTED_ON', direction: 'out', peerLabels: ['IoModule'] }
  ],
  IoModule: [
    { type: 'ASSIGNED_TO', direction: 'out', peerLabels: ['DcsController'] },
    { type: 'MOUNTED_ON', direction: 'out', peerLabels: ['DcsController'] }
  ],
  Line: [
    { type: 'HAS_LINE', direction: 'in', peerLabels: ['Site'] },
    { type: 'HAS_SUBLINE', direction: 'in', peerLabels: ['Line'] }
  ],
  LineOperation: [
    { type: 'HAS_LINE_OPERATION', direction: 'in', peerLabels: ['Line'] },
    { type: 'USES_EQUIPMENT', direction: 'out', peerLabels: ['Equipment'] }
  ],
  LogicSolver: [{ type: 'PART_OF', direction: 'out', peerLabels: ['Site'] }],
  Material: [],
  NamedQuery: [],
  NetworkDevice: [
    { type: 'BELONGS_TO', direction: 'out', peerLabels: ['EmdbProject'] },
    { type: 'CONTAINS', direction: 'in', peerLabels: ['Asset', 'NetworkDevice', 'NetworkSegment'] }
  ],
  NetworkSegment: [
    { type: 'BELONGS_TO', direction: 'out', peerLabels: ['EmdbProject'] },
    { type: 'CONTAINS', direction: 'in', peerLabels: ['Asset', 'Site'] }
  ],
  Observable: [
    { type: 'HAS_OBSERVABLE', direction: 'in', peerLabels: ['Equipment', 'Line', 'Part'] }
  ],
  Observer: [],
  Operation: [
    { type: 'EXECUTED_ON', direction: 'out', peerLabels: ['Equipment'] },
    { type: 'HAS_OPERATION', direction: 'in', peerLabels: ['WorkOrder'] },
    { type: 'RAN_ON', direction: 'out', peerLabels: ['Equipment'] }
  ],
  OperatorPhrase: [],
  Organization: [],
  PLCDataType: [{ type: 'BELONGS_TO', direction: 'out', peerLabels: ['Controller'] }],
  PLCDataTypeMember: [{ type: 'HAS_MEMBER', direction: 'in', peerLabels: ['PLCDataType'] }],
  PLCTag: [
    { type: 'CONTROLS', direction: 'out', peerLabels: ['PLCTag'] },
    { type: 'HAS_TAG', direction: 'in', peerLabels: ['AOI', 'Controller', 'Program', 'Routine'] }
  ],
  Part: [{ type: 'HAS_PART', direction: 'in', peerLabels: ['Equipment', 'Part'] }],
  Phase: [{ type: 'USES_EQUIPMENT', direction: 'out', peerLabels: ['Equipment'] }],
  Problem: [],
  Procedure: [
    {
      type: 'PROCEDURE_FOR',
      direction: 'out',
      peerLabels: ['Equipment', 'HumanLabor', 'Line', 'LineOperation', 'Process']
    }
  ],
  Process: [
    { type: 'HAS_PROCESS', direction: 'in', peerLabels: ['Organization'] },
    { type: 'HAS_SUBPROCESS', direction: 'in', peerLabels: ['Process'] }
  ],
  ProcessDeviation: [{ type: 'OCCURRED_ON', direction: 'out', peerLabels: ['Equipment'] }],
  Product: [],
  ProductionGoal: [{ type: 'HAS_PRODUCTION_GOAL', direction: 'in', peerLabels: ['Line'] }],
  Program: [{ type: 'BELONGS_TO', direction: 'out', peerLabels: ['Controller'] }],
  Project: [],
  ProtectiveFunction: [
    { type: 'HAS_PROTECTIVE_FUNCTION', direction: 'in', peerLabels: ['Line'] },
    {
      type: 'IMPLEMENTED_BY',
      direction: 'out',
      peerLabels: ['FunctionLogicDiagram', 'SafetyPoint']
    },
    { type: 'SOLVED_BY', direction: 'out', peerLabels: ['LogicSolver'] }
  ],
  PssEventJournal: [
    { type: 'HAS_EVENT_JOURNAL', direction: 'in', peerLabels: ['Database', 'PssTag'] }
  ],
  PssTag: [{ type: 'HAS_PSS_TAG', direction: 'in', peerLabels: ['Database'] }],
  QualityResult: [{ type: 'HAS_QUALITY_RESULT', direction: 'in', peerLabels: ['Batch'] }],
  QueryTag: [],
  Recipe: [{ type: 'USES_EQUIPMENT', direction: 'out', peerLabels: ['Equipment'] }],
  ReferenceDocument: [{ type: 'PART_OF', direction: 'out', peerLabels: ['Site'] }],
  RobotArm: [{ type: 'HOSTS', direction: 'in', peerLabels: ['RobotController'] }],
  RobotCondition: [
    { type: 'DEFINES', direction: 'in', peerLabels: ['RobotController'] },
    { type: 'USED_BY', direction: 'out', peerLabels: ['RobotJob'] }
  ],
  RobotController: [
    { type: 'CONTROLS', direction: 'out', peerLabels: ['Equipment'] },
    { type: 'COORDINATES', direction: 'in', peerLabels: ['Controller'] },
    { type: 'SUPERVISES', direction: 'in', peerLabels: ['RobotController'] }
  ],
  RobotIOSignal: [
    { type: 'DEFINES', direction: 'in', peerLabels: ['RobotController'] },
    { type: 'READ_BY', direction: 'out', peerLabels: ['RobotJob'] },
    { type: 'WRITTEN_BY', direction: 'out', peerLabels: ['RobotJob'] }
  ],
  RobotJob: [{ type: 'HAS_JOB', direction: 'in', peerLabels: ['RobotArm'] }],
  Role: [
    { type: 'REQUIRES_SKILL_LEVEL', direction: 'in', peerLabels: ['Procedure'] },
    { type: 'STAFFED_BY', direction: 'in', peerLabels: ['CrewRequirement', 'HumanLabor'] }
  ],
  Routine: [{ type: 'BELONGS_TO', direction: 'out', peerLabels: ['AOI', 'Program'] }],
  SafetyPoint: [{ type: 'CONTAINS', direction: 'in', peerLabels: ['FunctionLogicDiagram'] }],
  ScheduleProfile: [{ type: 'BELONGS_TO', direction: 'out', peerLabels: ['Compute'] }],
  Script: [],
  Setpoint: [{ type: 'HAS_SETPOINT', direction: 'in', peerLabels: ['Equipment', 'Part'] }],
  Site: [{ type: 'HAS_SITE', direction: 'in', peerLabels: ['Organization'] }],
  SoapContract: [{ type: 'USES_CONTRACT', direction: 'in', peerLabels: ['SoapEndpoint'] }],
  SoapEndpoint: [
    { type: 'HAS_SOAP_ENDPOINT', direction: 'in', peerLabels: ['Organization', 'Site'] }
  ],
  SoapOperation: [{ type: 'DECLARES_OPERATION', direction: 'in', peerLabels: ['SoapContract'] }],
  SrsSection: [{ type: 'PART_OF', direction: 'out', peerLabels: ['Site'] }],
  Table: [{ type: 'CONTAINS_TABLE', direction: 'in', peerLabels: ['Database'] }],
  Tag: [
    { type: 'CONTAINS', direction: 'in', peerLabels: ['Folder'] },
    { type: 'HAS_MEMBER', direction: 'in', peerLabels: ['UDTInstance'] },
    { type: 'PROVIDES', direction: 'in', peerLabels: ['TagProvider'] }
  ],
  TagProvider: [{ type: 'HAS_TAG_PROVIDER', direction: 'in', peerLabels: ['Compute'] }],
  UDTDefinition: [
    { type: 'CONTAINS', direction: 'in', peerLabels: ['Folder'] },
    { type: 'PROVIDES', direction: 'in', peerLabels: ['TagProvider'] }
  ],
  UDTInstance: [
    { type: 'CONTAINS', direction: 'in', peerLabels: ['Folder'] },
    { type: 'HAS_MEMBER', direction: 'in', peerLabels: ['UDTInstance'] },
    { type: 'PROVIDES', direction: 'in', peerLabels: ['TagProvider'] }
  ],
  UDTMember: [
    { type: 'BELONGS_TO', direction: 'out', peerLabels: ['UDTDefinition'] },
    { type: 'HAS_MEMBER', direction: 'in', peerLabels: ['UDTDefinition', 'UDTMember'] }
  ],
  UDTParameter: [
    {
      type: 'HAS_MEMBER',
      direction: 'in',
      peerLabels: ['UDTDefinition', 'UDTInstance', 'UDTMember']
    }
  ],
  Utility: [
    { type: 'HAS_UTILITY', direction: 'in', peerLabels: ['Line', 'Site'] },
    { type: 'REQUIRES_UTILITY', direction: 'in', peerLabels: ['Equipment'] }
  ],
  Vendor: [
    { type: 'MANUFACTURED_BY', direction: 'in', peerLabels: ['Part'] },
    { type: 'SUPPLIED_BY', direction: 'in', peerLabels: ['Part'] }
  ],
  View: [{ type: 'BELONGS_TO', direction: 'out', peerLabels: ['Project'] }],
  ViewComponent: [],
  VisionData: [
    { type: 'DEFINES', direction: 'in', peerLabels: ['RobotController'] },
    { type: 'USED_BY', direction: 'out', peerLabels: ['RobotJob'] }
  ],
  VisionJob: [{ type: 'HAS_JOB', direction: 'in', peerLabels: ['VisionSystem'] }],
  VisionProcess: [
    { type: 'DEFINES', direction: 'in', peerLabels: ['RobotController'] },
    { type: 'USED_BY', direction: 'out', peerLabels: ['RobotJob'] }
  ],
  VisionSystem: [{ type: 'COORDINATES', direction: 'in', peerLabels: ['Controller'] }],
  WorkOrder: []
}
